import auth from '../apis/auth';
import { stopSubmit } from 'redux-form';
import { 
    FETCH_ME,
    FETCH_BUSINESS,
    EDIT_ME,
    EDIT_BUSINESS,
    SHOW_ERROR,
    SUBMIT_START_SURVEY,
    CHECK_START_SURVEY
} from './types';
import errorObject from '../components/helpers/errorObject';

export const fetchMe = () => async dispatch => {
    await auth.get('/api/users/me')
        .then(response =>{
            dispatch({ type: FETCH_ME, payload: response.data})
        })
        .catch(error => {
            dispatch({ type: SHOW_ERROR, payload: error.response.data });
        })
};

export const fetchBusiness = () => async dispatch => {
    await auth.get('/api/users/business')
        .then(response =>{
            dispatch({ type: FETCH_BUSINESS, payload: response.data})
        })
        .catch(error => {
            dispatch({ type: SHOW_ERROR, payload: error.response.data });
        })
};

export const editMe = (formValues) => async dispatch => {
    await auth.post('/api/users/update_user', formValues)
        .then(response =>{
            dispatch({ type: EDIT_ME, payload: response.data})
        })
        .catch(error => {
            if (error.response.data.detail.constructor === Array) {
                const errorObj = errorObject(error.response.data.detail)
                dispatch(stopSubmit('detailsForm', errorObj));
            }
            else {
                dispatch({ type: SHOW_ERROR, payload: error.response.data });
            }
        })
};

export const editBusiness = (formValues) => async dispatch => {
    await auth.post('/api/users/update_business', formValues)
        .then(response =>{
            dispatch({ type: EDIT_BUSINESS, payload: response.data})
        })
        .catch(error => {
            if (error.response.data.detail.constructor === Array) {
                const errorObj = errorObject(error.response.data.detail)
                dispatch(stopSubmit('detailsForm', errorObj));
            }
            else {
                dispatch({ type: SHOW_ERROR, payload: error.response.data });
            }
        })
};

export const submitStartSurvey = (formValues) => async dispatch => {
    await auth.post('/api/company/start_survey', formValues)
        .then(response =>{
            dispatch({ type: SUBMIT_START_SURVEY, payload: response.data})
        })
        .catch(error => {
            dispatch({ type: SHOW_ERROR, payload: error.response.data });
        })
};

export const checkStartSurvey = () => async dispatch => {
    await auth.get('/api/company/check_start_survey')
        .then(response =>{
            dispatch({ type: CHECK_START_SURVEY, payload: response.data})
        })
        .catch(error => {
            dispatch({ type: SHOW_ERROR, payload: error.response.data });
        })
};